var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',_vm._g(_vm._b({attrs:{"src":require("@/assets/images/logo.png"),"contain":"","min-height":"50"}},'v-img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }